// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-formContainer * {
	font-weight: normal;
}

.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-formContainer h5 {
	font-weight: bold;
}

.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-panelRow {
	padding: 5px 0;
}

.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-panelRow > * {
	width: 50%;
}

.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-panelRowBottomBorder {
	border-bottom: var(--StandardBorder);
}

.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-titleRow {
	-ms-flex-align: center;
	    align-items: center;
	color: var(--Black600);
	display: -ms-flexbox;
	display: flex;
}

.SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-titleIcon {
	margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/SiteAdmin/FormDefinitionConfig/FormAttributesPanel.module.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,sBAAmB;KAAnB,mBAAmB;CACnB,sBAAsB;CACtB,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,oBAAoB;AACrB","sourcesContent":[".formContainer * {\n\tfont-weight: normal;\n}\n\n.formContainer h5 {\n\tfont-weight: bold;\n}\n\n.panelRow {\n\tpadding: 5px 0;\n}\n\n.panelRow > * {\n\twidth: 50%;\n}\n\n.panelRowBottomBorder {\n\tborder-bottom: var(--StandardBorder);\n}\n\n.titleRow {\n\talign-items: center;\n\tcolor: var(--Black600);\n\tdisplay: flex;\n}\n\n.titleIcon {\n\tmargin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-formContainer`,
	"panelRow": `SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-panelRow`,
	"panelRowBottomBorder": `SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-panelRowBottomBorder`,
	"titleRow": `SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-titleRow`,
	"titleIcon": `SiteAdmin-FormDefinitionConfig-FormAttributesPanel-module-titleIcon`
};
module.exports = ___CSS_LOADER_EXPORT___;
